import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  addContainer: {
    borderRadius: 6,
    border: `2px solid ${theme.colorPalette.white_10}`,
    backgroundColor: theme.colors.white_30,
    padding: theme.spacing(3, 4, 3, 8),
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.10)'
  },
  button: {
    width: 102
  },
  addButton: {
    backgroundColor: theme.colorPalette.orange_10,
    color: theme.colors.white,
    borderRadius: '50%',
    width: 36,
    height: 36,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  addLabel: {
    fontSize: 16,
    fontWeight: 400,
    margin: 0,
    color: theme.colorPalette.green_20
  },
  coverageCard: {
    background: theme.colorPalette.beige_35,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8)
  },
  addFormContainer: {
    padding: theme.spacing(4, 8),
    border: `1px solid ${theme.colorPalette.white_10}`,
    borderRadius: theme.sizes.roundCorners
  },
  livestockInfoTextContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    '& svg': {
      marginRight: theme.spacing(2)
    }
  },
  livestockInfoText: {
    fontSize: '12px',
    color: theme.colorPalette.green_30
  },
  sectionFooter: {
    marginTop: theme.spacing(2)
  },
  noBorderContainer: {
    width: '100%',
    backgroundColor: theme.colorPalette.beige_35,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  greenCoverageCard: {
    background: theme.colorPalette.green_20,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8)
  },
  totalsItem: {
    backgroundColor: theme.colorPalette.white_10,
    borderRadius: 6,
    padding: `${theme.spacing(4)}px ${theme.spacing(6)}px !important`
  },
  totalsItemTitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2)
  },
  totalsItemName: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.colorPalette.green_15,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: 8
    }
  },
  totalsItemStack: {
    display: 'flex',
    flexDirection: 'column'
  },
  totalsItemLabel: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.green_75,
    textTransform: 'uppercase'
  },
  totalsItemValue: {
    fontSize: 16,
    color: theme.colorPalette.green_15,
    fontWeight: 600
  },
  totalsDivider: {
    width: '1px',
    height: '34px',
    backgroundColor: theme.colorPalette.green_75
  },
  snowWeightCoverage: {
    minHeight: '66px !important'
  },
  coverageSubtitle: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  }
}));

export default useStyles;
